import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ChartLineIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "chart-line",
  "ChartLineIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.66683 1.33337L2.66683 13.3334L14.6668 13.3334V14.6667L1.3335 14.6667L1.3335 1.33337L2.66683 1.33337Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M13.5321 4.20111L14.4736 5.14525L12.2811 7.33181C12.2811 7.33181 12.2812 7.3318 12.2811 7.33181C11.5034 8.10758 10.7517 8.85757 10.4718 9.13747L10.0004 9.60887L7.33376 6.94221L4.00043 10.2755L3.05762 9.33273L7.33376 5.05659L10.0007 7.72356C10.3601 7.36487 10.8447 6.88135 11.3395 6.38781L12.3995 5.33065L13.5321 4.20111Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M10.667 4H14.667V8H13.3337V5.33333H10.667V4Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ChartLineIcon;
